import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

import { useNotification } from "@hooks/useNotification";
import { employeProtocolActions } from "@store/actions";

import Button from "@components/tailwindComponents/Button";
import ListboxSimple from "@components/tailwindComponents/ListboxSimple";

import { OnboardingEmployeProtocol } from "@services/all.services";

import ModalDelete from "../components/ModalDelete";

export default function LoadProtocolHeader({
  employeProtocolMetadata,
  selectedEmployeProtocol,
  reloadEmployeProtocol
}) {
  const reduxDispatch = useDispatch();
  const { t } = useTranslation("beginEnd.protocol");
  const { showError, showSuccess } = useNotification();

  const protocolList = useSelector(
    ({ onboarding }) => onboarding.protocol.list
  );

  const [selectedProtocol, setSelectedProtocol] = useState(null);
  const [mustWait, setWait] = useState(false);
  async function onLoadClicked() {
    try {
      setWait(true);
      const response = await OnboardingEmployeProtocol.createProtocol({
        queryParams: employeProtocolMetadata,
        protocolId: selectedProtocol?._id
      });
      reduxDispatch(employeProtocolActions.loadData(response._id));
      showSuccess("load_action_success", { object: "aProtocol" });
      setWait(false);
    } catch (err) {
      if (err?.error?.response?.data?.message === "protocol already exists") {
        showError(
          "Le protocole existe déjà, réactualisez la page pour l'afficher"
        );
      } else {
        showError("error");
      }
      console.error(err);
      setWait(false);
    }
  }

  const [showModalDelete, setShowModal] = useState(false);

  function onDeleteClicked() {
    setShowModal(!showModalDelete);
  }

  async function deleteProtocol() {
    try {
      setWait(true);
      const protocolId = selectedEmployeProtocol._id;
      await OnboardingEmployeProtocol.deleteProtocol(protocolId);
      reduxDispatch(employeProtocolActions.loadData());

      showSuccess("delete_action_success", { object: "protocol" });
      setShowModal(false);
      setWait(false);
    } catch (error) {
      console.log(error);
      showError("error");
      setWait(false);
    }
  }
  return (
    <div>
      <h3 className="arh-mb-5 arh-font-poppins arh-text-xl arh-font-semibold arh-text-darkColor">
        {t("Charger un protocole")}
      </h3>
      <div className="arh-flex arh-w-full arh-items-center arh-justify-between arh-bg-greyColor arh-px-6 arh-py-5">
        <div className="arh-mt-4 arh-w-inputFilter">
          <h6 className="arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor">
            {t("Sélectionner le protocole à charger")}
          </h6>
          <div className="arh-w-full">
            <ListboxSimple
              placeholder={selectedEmployeProtocol?.name || t("Protocole")}
              name="employeeProtocol"
              optionList={protocolList}
              selectedValue={selectedProtocol}
              setSelectedValue={setSelectedProtocol}
              readOnly={selectedEmployeProtocol?._id ? true : false}
            />
          </div>
        </div>
        <div className="arh-flex arh-items-center">
          {selectedEmployeProtocol?._id ? (
            <Button
              variant="outlined"
              onClick={onDeleteClicked}
              disabled={mustWait}
            >
              {t("Supprimer le protocole")}
            </Button>
          ) : (
            <Button
              onClick={onLoadClicked}
              disabled={!selectedProtocol}
              wait={mustWait}
            >
              {t("Charger le protocole")}
            </Button>
          )}
        </div>
      </div>

      <ModalDelete
        show={showModalDelete}
        isLoading={mustWait}
        onDelete={deleteProtocol}
        onCloseClicked={onDeleteClicked}
        object={t("ce protocole")}
      />
    </div>
  );
}
